import { Fragment } from "react/jsx-runtime"
import welcomePage from "assets/Welcome_Screen.png"

export const HomePageView = () => {
    return (
        <Fragment>
            <div className="welcome_img"> 
                <img src={welcomePage} />
            </div>
        </Fragment>
    )
}